import React from 'react'
import { Link } from 'react-router-dom';
import PageTitle from './includes/PageTitle';


export default function ComingSoon() {
  return (
    <>
        <PageTitle title="Coming Soon - ALMOSTINVISIBLE" />

        <div className='d-flex align-items-center' style={{backgroundColor: "black", color: 'white', height: "80vh"}}>
            <div className='container'>
                <h1 className="unbounded" style={{fontSize: "65px"}}>
                    COMING SOON!!!
                </h1>
                <Link to="/all-products" className='white-bordered-button'>
                    Shop Other Products
                </Link>
            </div>
        </div>
    </>
  )
}
